import { usePatientStore } from "../../store/Patient";
import {
	useSheetStore,
	SheetContentType,
} from "../../store/Sheets/sheet.store";
import { XCircle } from "lucide-react";
import { Tooltip } from "@mui/material";
import { APP_BAR_COLORS } from "../../layout/layout-components/app-bar/app-bar-constants";
import { PatientEntityType } from "@/lib/supabase/supabaseTypes";

export const PatientTabs: React.FC = () => {
	const { pinnedPatients, unpinAllPatients, unpinPatient, patientName } =
		usePatientStore((state) => ({
			pinnedPatients: Object.values(state.pinnedPatients),
			unpinAllPatients: state.unpinAllPatients,
			unpinPatient: state.unpinPatient,
			patientName: state.patientName,
		}));

	const { openSheet, sheets } = useSheetStore((state) => ({
		openSheet: state.openSheet,
		sheets: state.sheets,
	}));

	if (pinnedPatients.length === 0) {
		return null;
	}

	const handlePatientClick = (patient: PatientEntityType) => {
		// Check if top sheet is already patient sheet with same id
		const topSheet = sheets[sheets.length - 1];
		if (
			topSheet &&
			topSheet.sheetContentType === SheetContentType.PATIENT &&
			topSheet.props?.patient?.id === patient.id
		) {
			return;
		}
		openSheet(SheetContentType.PATIENT, { patient });
	};

	const handleUnpinPatient = (e: any, patientId: string | null) => {
		if (patientId) {
			unpinPatient(patientId);
		}
	};

	return (
		<div
			className={`h-8 ${APP_BAR_COLORS.BACKGROUND} pr-3.5 flex items-center`}
		>
			<div className="flex-1 flex items-center gap-2 overflow-x-auto hide-scrollbar">
				<div className="pinned-patients-container flex-1 overflow-x-auto hide-scrollbar">
					<div className="flex items-center gap-1.5">
						{pinnedPatients.map((patient) => (
							<div
								key={patient.id}
								className="group flex items-center gap-1 px-2 h-6 text-xs rounded-md hover:bg-stone-300 bg-stone-200 cursor-pointer transition-colors whitespace-nowrap"
							>
								<div
									onClick={() => handlePatientClick(patient)}
									className="flex items-center gap-1"
								>
									<span className="font-medium max-w-[120px] truncate">
										{patientName(patient)}
									</span>
								</div>
								<XCircle
									className="w-3 h-3 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
									onClick={(e: any) =>
										handleUnpinPatient(
											e,
											patient.id as string
										)
									}
								/>
							</div>
						))}
					</div>
				</div>
			</div>
			{pinnedPatients.length > 1 && (
				<Tooltip title="Alle entpinnen">
					<button
						onClick={unpinAllPatients}
						className="ml-2 text-gray-400 hover:text-gray-600 flex items-center text-xs"
					>
						<span className="mr-1">Alle Patienten entfernen</span>
						<XCircle className="w-3 h-3" />
					</button>
				</Tooltip>
			)}
		</div>
	);
};
